import ready from '../../../../src-core/js/utils';
import { initSliderCards, showCard, hideCard } from './reveal-card.js';

const selectors = {
  container: '.finder--admissions-counselor',
  step1: '.finder-form-step-1',
  step2: '.finder-form-step-2',
  step3: '.finder-form-step-3',
  state: '#finder-state',
  county: '#finder-county',
  reset: '#finder-form--reset',
  studentType: '[name=student-type]',
  counselor: '.people-listing',
  feedback: '.finder-form-feedback--content',
}

function makeOption(value, name = value) {
  return `<option value="${value}">${name}</option>`;
}


function updateCounselors(data) {
  const finderStudentType = document.querySelectorAll(selectors.studentType);
  const finderState = document.querySelector(selectors.state);
  const finderCounty = document.querySelector(selectors.county);
  const feedback = document.querySelectorAll(selectors.feedback)


  let studentTypeEl = null;
  let shownCounselors = [];


  finderStudentType.forEach(studentType => {
    if (studentType.checked) {
      studentTypeEl = studentType;
    }
  });


  if (studentTypeEl) {
    let shownText = ``;

    shownCounselors = data.by_admissions_counselor_for[studentTypeEl.value] || [];

    if (studentTypeEl.value == 'first-year') {
      shownText += 'First Year Students'

      if (finderState.selectedIndex > 0) {
        const coveredCounties = data.county_coverage[finderState.value] || [];
        const wholeStateCounselors = data.state_coverage[finderState.value] || [];

        shownText += `, ${finderState.querySelectorAll('option')[finderState.selectedIndex].textContent}`
        shownCounselors = [...shownCounselors, ...wholeStateCounselors];

        if (Object.keys(coveredCounties).length && finderCounty.selectedIndex > 0) {
          shownCounselors = [...shownCounselors, ...coveredCounties[finderCounty.value]];
          shownText += `, ${finderCounty.querySelectorAll('option')[finderCounty.selectedIndex].textContent} County`
        }
      }
    } else if (studentTypeEl.value == 'transfer') {
      shownText += 'Transfer Students'
    } else if (studentTypeEl.value == 'international') {
      shownText += 'International Students'
    }


    const newContent = `
      Showing ${shownCounselors.length} Counselor${shownCounselors.length !== 1 ? 's' : ''}
      <span class="weight-normal" aria-hidden="true">for
      ${shownText}
    `;

    feedback.forEach(el => el.innerHTML = newContent)

    document.querySelectorAll(selectors.counselor)
      .forEach(el =>
        shownCounselors.includes(Number(el.dataset.person_id))
          ? el.classList.remove('hidden')
          : el.classList.add('hidden')
      );
  } else {
    feedback.forEach(el => el.innerHTML = "Showing All Counselors");

    document.querySelectorAll(selectors.counselor)
      .forEach(el => el.classList.remove('hidden'));

  }
}

function clearCounselorAOS() {
  // This removes AOS scroll animations so filtered counselors don't get stuck on the autoscroll
  document.querySelectorAll(selectors.counselor).forEach(el => {
    el.removeAttribute('data-aos');
  });
}

function scrollNudge() {

  clearCounselorAOS();

  const target = document.getElementById('finder-form-start');
  if (!target) return;

  const targetRect = target.getBoundingClientRect();
  const scrollTop = window.scrollY;
  const targetOffsetTop = targetRect.top + scrollTop;
  const viewportHeight = window.innerHeight;
  const scrollTo = targetOffsetTop - (viewportHeight / 2) + (targetRect.height / 2);

  window.scrollTo({
    top: scrollTo,
    behavior: 'smooth'
  });
}

async function hideArrows() {
  const finderStep1 = document.querySelector(selectors.step1);
  const finderStep2 = document.querySelector(selectors.step2);
  const finderStep3 = document.querySelector(selectors.step3);

  finderStep1.classList.remove('finder-form-start', 'finder-form-end', 'show-arrow')
  finderStep2.classList.remove('finder-form-start', 'finder-form-end', 'show-arrow')
  finderStep3.classList.remove('finder-form-start', 'finder-form-end', 'show-arrow')
}

async function showArrow(el, type) {
  hideArrows();

  const step = el.closest('.finder-form-step');
  if (step) {
    step.classList.add(`finder-form-${type}`);
    step.classList.add('show-arrow')
  }
}

function hideInput(el) {
  el.parentElement.classList.remove('shown');
}
function showInput(el) {
  el.parentElement.classList.add('shown');
}

function onReset(data) {
  const finderReset= document.querySelector(selectors.reset);
  const finderStep1 = document.querySelector(selectors.step1);
  const finderStep2 = document.querySelector(selectors.step2);

  const finderState = document.querySelector(selectors.state);
  const finderCounty = document.querySelector(selectors.county);
  const finderStudentType = document.querySelectorAll(selectors.studentType);

  return async (e) => {
    hideArrows();

    finderReset.classList.add('hidden');

    finderState.selectedIndex = 0;
    finderCounty.selectedIndex = 0;

    finderStudentType.forEach(studentType => studentType.checked = false);

    updateCounselors(data);

    await hideCard(finderStep2);

    showArrow(finderStep1)

  }
}

function onSelectStudentType(data) {
  const finderStep1 = document.querySelector(selectors.step1);
  const finderStep2 = document.querySelector(selectors.step2);
  const finderReset= document.querySelector(selectors.reset);

  return async (e) => {
    hideArrows();
    const finderState = document.querySelector(selectors.state);
    const finderCounty = document.querySelector(selectors.county);

    finderState.selectedIndex = 0;
    finderCounty.selectedIndex = 0;

    if (e.target.value == 'first-year') {
      hideInput(finderCounty);
      await showCard(finderStep2);
      showArrow(finderStep2, 'start');

      // Don't filter counselors yet for first-year.
    } else {
      await hideCard(finderStep2);
      updateCounselors(data);
      await showArrow(finderStep1, 'end');
      scrollNudge();
    }

    finderReset.classList.remove('hidden');
  }
}


function onSelectState(data) {
  const finderReset= document.querySelector(selectors.reset);

  return async (e) => {
    hideArrows();

    const finderStep2 = document.querySelector(selectors.step2);
    const finderCounty = document.querySelector(selectors.county);

    const state = e.target.value;
    const coveredCounties = data.county_coverage[state];

    finderCounty.selectedIndex = 0;

    if (coveredCounties) {
        finderCounty.innerHTML = `
          <option selected>Select...</option>
          ${Object.keys(coveredCounties).map(e => makeOption(e))}
        `;
        showInput(finderCounty);
        showArrow(finderStep2, 'start');

        // Don't filter until county is selected.
    } else {
      hideInput(finderCounty);
      updateCounselors(data);
      await showArrow(finderStep2, 'end');
      scrollNudge();
    }
    finderReset.classList.remove('hidden');
  }
}
function onSelectCounty(data) {
  const finderReset= document.querySelector(selectors.reset);

  return async (/* e */) => {
    hideArrows();
    const finderStep2 = document.querySelector(selectors.step2);

    updateCounselors(data);
    await showArrow(finderStep2, 'end');
    scrollNudge();
    finderReset.classList.remove('hidden');
  }
}

export default function initFinderAdmissionsCounselor() {
  const finderContainer = document.querySelector(selectors.container);
  const finderState = document.querySelector(selectors.state);
  const finderCounty = document.querySelector(selectors.county);
  const finderReset= document.querySelector(selectors.reset);
  const finderStudentType = document.querySelectorAll(selectors.studentType);
  
  if(finderContainer) {
    const data_string = finderContainer.dataset[ 'admissions_counsellor_data' ];

    if (data_string) {
      try {
        const finderData = JSON.parse(data_string)
  
        finderState.addEventListener('change', onSelectState(finderData));
        finderCounty.addEventListener('change', onSelectCounty(finderData));
        finderReset.addEventListener('click', onReset(finderData));
        finderStudentType.forEach(el => el.addEventListener('change', onSelectStudentType(finderData)));
      }
      catch (e) {
        console.error('Error parsing admissions counselor data', e);
      }
  
    }
  }
}

ready(() => {
  initSliderCards();
  initFinderAdmissionsCounselor();
});
